export default {
  data() {
    return {
      portfolios: [
        {
          id: 1,
          img: require(`@/assets/images/portfolio/project-1.jpg`),
          title: "MOCKUP PROJECT",
          project: "Website",
          client: "Envato",
          language: "HTML,CSS,Javascript",
          preview: "www.envato.com",
          previewLink: "https://www.envato.com/",
        },
        {
          id: 2,
          img: require(`@/assets/images/portfolio/project-2.jpg`),
          title: "YOUTUBE PROJECT",
          project: "Website",
          client: "Envato",
          language: "Camtasia Studio",
          preview: "www.youtube.com",
          previewLink: "https://www.youtube.com/",
        },
        {
          id: 3,
          img: require(`@/assets/images/portfolio/project-3.jpg`),
          title: "INSTAGRAM PROJECT",
          project: "Restaurant Menu ",
          client: "Instagram",
          language: "Slider Group",
          preview: "www.instagram.com",
          previewLink: "https://www.instagram.com/thesliderproject/?hl=en",
        },
        {
          id: 4,
          img: require(`@/assets/images/portfolio/project-4.jpg`),
          title: "DRIBBBLE PROJECT",
          project: "Project Shoot",
          client: "dribbble",
          language: "React",
          preview: "www.dribbble.com",
          previewLink: "https://dribbble.com/ib-themes",
        },
        {
          id: 5,
          img: require(`@/assets/images/portfolio/project-5.jpg`),
          title: "BEHANCE PROJECT",
          project: "Live Shoot",
          client: "Behance",
          language: "React,Bootstrap",
          preview: "www.behance.com",
          previewLink: "https://www.behance.net/ib-themes",
        },
        {
          id: 6,
          img: require(`@/assets/images/portfolio/project-6.jpg`),
          title: "SAAS PROJECT",
          project: "Web Application",
          client: "Themeforest",
          language: "HTML, CSS, ReactJs",
          preview: "www.themeforest.com",
          previewLink:
            "https://themeforest.net/item/deski-saas-software-react-template/33799794",
        },
        {
          id: 7,
          img: require(`@/assets/images/portfolio/project-7.jpg`),
          title: "MOCKUP PROJECT",
          project: "Website",
          client: "Pexels",
          language: "Adobe Photoshop",
          preview: "www.pexels.com",
          previewLink: "https://www.pexels.com/",
        },
        {
          id: 8,
          img: require(`@/assets/images/portfolio/project-8.jpg`),
          title: "FACEBOOK PROJECT",
          project: "Shoot",
          client: "Facebook",
          language: "Reactjs",
          preview: "www.facebook.com",
          previewLink: "https://www.facebook.com/ibthemes",
        },
        {
          id: 9,
          img: require(`@/assets/images/portfolio/project-9.jpg`),
          title: "LINKEDIN PROJECT",
          project: "Website",
          client: "Linkedin",
          language: "Vue 3",
          preview: "www.linkedin.com",
          previewLink:
            "https://www.linkedin.com/in/ib-themes-company-469408207/recent-activity/shares/",
        },
      ],
    };
  },
};
